import { RollbackCircleSVG } from "@components/svgs/rollback-circle";
import { SHStack, SHStackProps } from "@components/design-systems";
import { useTheme } from "@mui/material";

type MSFilterResetIconProps = SHStackProps & {
  onClick: () => void;
  disabled?: boolean;
};

export const MSFilterResetIcon = ({
  onClick,
  disabled = false,
  ...other
}: MSFilterResetIconProps) => {
  const { palette, shadows } = useTheme();

  const handleOnClick = () => {
    !disabled && onClick();
  };

  return (
    <SHStack
      borderRadius={"50%"}
      alignItems={"center"}
      justifyContent={"center"}
      width={24}
      height={24}
      boxShadow={shadows[1]}
      sx={{
        "&:hover": {
          boxShadow: "none",
          transition: "all 0.3s ease",
        },
        cursor: "pointer",
        "&:active": {
          boxShadow: `inset 1px 2px 2px ${palette.warning.main}`,
        },
      }}
      {...other}
      onClick={handleOnClick}
    >
      <RollbackCircleSVG
        color={disabled ? palette.action.disabled : palette.error.main}
      />
    </SHStack>
  );
};
